import { render, staticRenderFns } from "./ServiceAssetsList.vue?vue&type=template&id=5919c30a&"
import script from "./ServiceAssetsList.vue?vue&type=script&lang=js&"
export * from "./ServiceAssetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports